import { jsxs, jsx } from "react/jsx-runtime";
const DatasetsIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx("path", { d: "M880 112H264C259.6 112 256 115.6 256 120V176C256 180.4 259.6 184 264 184H840V760C840 764.4 843.6 768 848 768H904C908.4 768 912 764.4 912 760V144C912 126.3 897.7 112 880 112Z" }),
  /* @__PURE__ */ jsx("path", { d: "M382 510H514V642H382V510Z" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M752 240H144C126.3 240 112 254.3 112 272V880C112 897.7 126.3 912 144 912H752C769.7 912 784 897.7 784 880V272C784 254.3 769.7 240 752 240ZM318 312H382V446H514V312H578V446H712V510H578V642H712V706H578V840H514V706H382V840H318V706H184V642H318V510H184V446H318V312Z"
    }
  )
] });
export {
  DatasetsIcon
};
